export default __webpack_public_path__ + "static/media/prod2.d028c2a8.png";